import { logger } from '@/utils/logger';
import { AuthOptions } from '@/components/auth/AuthOptions';
import { useAuth } from '@/context/auth-context';
import appServices from '@/services/appServices';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';

const authService = appServices.auth;

export const Route = createFileRoute('/auth/')({
  component: RouteComponent,
  beforeLoad: () => {
    logger.debug('/auth/index beforeLoad check');

    // Only redirect if user is already authenticated when landing on this page
    // This prevents redirect loops during the authentication process
    if (!authService.isInitialized) {
      logger.debug('Auth service not initialized yet, waiting...');
      return;
    }

    if (authService.isAuthenticated()) {
      const userSettings = authService.getUserSettings();
      logger.debug('User already authenticated, userSettings:', userSettings);

      if (userSettings?.onboarding_completed === 'true') {
        logger.debug('Redirecting to /dashboard (onboarding completed)');
        throw redirect({ to: '/dashboard' });
      } else {
        logger.debug('Redirecting to /onboarding (onboarding not completed)');
        throw redirect({ to: '/onboarding' });
      }
    }

    logger.debug('Not authenticated, showing auth page');
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const { createGuestSession, updateProfile } = useAuth();
  return (
    <AuthOptions
      onTryAsGuest={() => {
        createGuestSession()
          .then(() => {
            return updateProfile({ onboarding_completed: 'false' });
          })
          .then(() => {
            navigate({ to: '/onboarding' });
          })
          .catch((err) => {
            logger.error('Failed to create guest session:', err);
            alert('Failed to create guest session');
          });
      }}
      onCreateAccount={() => {
        navigate({ to: '/auth/register' });
      }}
      onSignIn={() => {
        navigate({ to: '/auth/signin' });
      }}
      onBack={() => {}}
    />
  );
}
